import clsx from 'clsx';
import { ProductPopover } from '~/features/product-details/components/ProductOverview/components/ProductPopover/ProductPopover';
import { PriceLike } from '~/lib/salesforce/types';
import { Typography, TypographyProps } from '~/shared/components';
import { useUtils } from '~/shared/hooks/useUtils';
import styles from './ProductPrices.module.scss';

type Props = Omit<TypographyProps, 'children' | 'variant'> & {
    price: PriceLike;
    label?: string;
    priceType?: string;
    tooltip?: React.ReactNode;
};

export const ProductPrice: React.FC<Props> = ({
    price,
    label,
    priceType = price.type,
    tooltip,
    className,
    as = 'div',
    ...rest
}) => {
    const { convertPriceToLocale } = useUtils();

    return (
        <Typography
            className={clsx(styles.productPrice, className)}
            as={as}
            data-price-type={priceType}
            {...rest}
        >
            <Typography className={styles.priceAmount} variant="paragraph-XXL">
                {convertPriceToLocale(price.value)}
            </Typography>

            <Typography className={styles.priceLabel} variant="paragraph-S">
                {label ?? price.label}

                {!!tooltip && (
                    <ProductPopover align="end" alignOffset={-8}>
                        {tooltip}
                    </ProductPopover>
                )}
            </Typography>
        </Typography>
    );
};
